import { ValidateStep } from 'utils/Validations'

const EventForm = {
  el: {
    root: document.querySelector<HTMLElement>('.form__business-inquiry'),
    messageTempData: document.querySelector<HTMLElement>('.business-inquiry__temp-data'),
  },

  init() {    
    if (this.el.root) {
      this.el.root.addEventListener('submit', (e) => {
        if (!ValidateStep(this.el.root)) {
          e.preventDefault()
        }
      })
    }
  },

  handleTempDataMessage(hasTimeout: boolean) {
    if (this.el.messageTempData) {
      if (this.el.messageTempData.style.display == 'block') {
        if (hasTimeout) {
          setTimeout(() => {
            this.el.messageTempData.style.display = 'none'
          }, 10000)
        }
        else {
          this.el.messageTempData.style.display = 'none'
        }
      }
    }
  },


}

export default EventForm
